import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        known_power: null,
        house_type: null,
        selected_region: null,
        power_selected: 1000,
        room_type: null,
        surface: 10,
        radiator: {
            color: {
                name: 'Blanc reflet vert',
                class: 'degrade-blanc-reflet',
                checkColor: 'text-black',
            },
            orientation: 'horizontal',
            finition: 'Brillant',
            thermostat: 'Sans fil',
            towelDryers: '2',
        },
        piloting: 'true',
        resume: false,
        resumeLast: false,
        sent: false,
        configurations: [],
        selected_config: [],
    },
    mutations: {
        setData(state, payload) {
            state[payload[0]] = payload[1];
        }
        , setDataRad(state, payload) {
            state.radiator[payload[0]] = payload[1];
        }
    },
    actions: {},
    modules: {}
})
